import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'safeHtml',
    standalone: true
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(html: string): SafeHtml {
    html = '<div style="max-width:100%;"><style>div img {max-width: 100%;height: auto;}</style>'+html+'</div>'
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}



@Pipe({
    name: 'urlify',
    standalone: true
})
export class UrlifyPipe implements PipeTransform {

  transform(text: any): any {
    var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    return text.replace(urlRegex, function(url: string) {
      return '<a href="' + url + '">' + url + '</a>';
    });
  }
}